import { type AnyAction } from 'redux';
import { get } from 'lodash';
import { LOCALES } from '../../utils/locale';
import { CHANGE_LANGUAGE } from '../actions/actionTypes/settings';
import { REQUEST_TYPES } from '../../api/requests/requestTypes';
import { SEND_REQUEST_SUCCESS } from '../actions/actionTypes/request';
import { type SettingsState } from '../types';

export const initialState: SettingsState = {
    locale: LOCALES.DE,
    dataPrivacy: {
        isEnabled: true
    }
};

export const settings = (state = initialState, action: AnyAction): SettingsState => {
    const { type } = action;
    switch (type) {
        case CHANGE_LANGUAGE:
            return {
                ...state,
                locale: action.payload
            };
        case SEND_REQUEST_SUCCESS:
            if (action.request?.type === REQUEST_TYPES.GET_DATA_PRIVACY_CONFIG) {
                const dataPrivacy = {
                    isEnabled: get(
                        action.payload,
                        `data.data-privacy.data.isEnabled`,
                        true
                    ),
                    agentThreshold: get(
                        action.payload,
                        `data.data-privacy.data.agentThreshold`
                    )
                };

                return {
                    ...state,
                    dataPrivacy
                };
            }
            return state;
        default:
            return state;
    }
};
